import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { applyColor }from '~src/style/ColorService';

export const externalProviderTextTitleStyle: React.CSSProperties = {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'BentonSans-Medium',
    color: applyColor(DesignTokens.color.font.default.default, '#333333'),
    paddingBottom: 12
};

export const externalProviderTextSubTitleStyle: React.CSSProperties = {
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'BentonSans-Medium',
    color: applyColor(DesignTokens.color.font.default.default, '#333333'),
    paddingBottom: 12
};

export const externalProviderTextDescriptionStyle: React.CSSProperties = {
    width: 399,
    fontSize: 12,
    fontWeight: 350,
    fontFamily: 'BentonSans-Book',
    color: applyColor(DesignTokens.color.font.default.default, '#333333'),
    paddingBottom: 12
};

export const externalProviderSectionPadding: React.CSSProperties = {
    paddingBottom: 12
};

export const externalProviderTextInput: React.CSSProperties = {
    width: 399,
    height: 28
};

export const externalProviderNameClaimInput: React.CSSProperties = {
    width: 374,
    height: 28
};

export const externalProviderInlineAlert: React.CSSProperties = {
    paddingTop: 8,
    paddingBottom: 8
};

export const externalProviderTestButton: React.CSSProperties = {
    fontSize: 12,
    fontWeight: 350
};

export const dropDownWidgetTitleText: React.CSSProperties = {
    fontFamily: 'BentonSans-Medium',
    fontWeight: 500
};

export const dropDownWidgetDescriptionText: React.CSSProperties = {
    fontFamily: 'BentonSans-Book',
    paddingTop: '8px',
    fontSize: TabStyles.Typography.Sizing.Tiny,
};

export const dropDownWidgetListItem: React.CSSProperties = {
    padding: '4px 8px',
    whiteSpace: 'normal',
    borderRadius: '2px'
};

export const listItemTextStyle: React.CSSProperties = {
    paddingTop: '8px',
    paddingBottom: '8px',
    whiteSpace: 'normal',
    overflow: 'visible',
    wordWrap: 'break-word',
    borderRadius: '2px',
    textAlign: 'left',
};


export const embeddedDropDownWidgetText: React.CSSProperties = {
    fontFamily: 'BentonSans-Book',
    paddingTop: '2px',
    paddingBottom: '2px',
    fontSize: TabStyles.Typography.Sizing.Small,
};
